<template>
	<div class="page settings">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><path d="M578 980.7H420.6L395 823c-16.5-5.4-32.7-12.2-48.2-20l-131 95.4L104.4 787l95.3-131c-8-16-15-32.4-20.5-49.3l-160-25.2V424l160-25.2c5.6-17.2 12.6-34 21-50.3l-96.5-132.6L215 104.4l133.4 97c15-7.5 30.5-14 46.4-19.2l25.6-163H578L603.6 182c16.6 5.4 33 12 48.7 20l132-95 111.3 111.3-95 131.8c7.8 15.3 14.4 31.3 19.8 47.6l160.3 26v157.5l-160.3 26c-5.2 16-11.7 31.6-19.2 46.6L895 784.2 783.6 895.6l-129.4-93.2c-16.3 8.4-33.2 15.4-50.5 21L578 980.7zm-148-11h138.7L594 815l3.3-1c18.8-6 37.3-13.6 55-23l3-1.6L782.4 881l98-98-89.2-124-3.2-3.2 1.8-3.6c8.6-16.6 15.7-34 21.3-51.7l1.2-4h6L969.7 572V433.3l-151-24.6h-6.5l-1.2-4c-5.7-18.2-13-36-22-53l-2-3.6 4.3-4.3L881 219.5l-98-98-124 89.3-4.6 4.6-3.6-2c-17.2-9-35.3-16.5-53.6-22.2l-3.3-1-25.2-160H430L405.5 187v3.6l-3.8 1.2c-17.5 5.5-34.7 12.7-51 21l-3.6 2-2.8-2.8-128-93-98 98 95 130.5-1.6 3c-9.3 17.5-17 36-22.8 54.8l-1 3.3-157.5 24.7V572l157.4 24.8 1 3.3c5.8 18.4 13.3 36.5 22.3 53.8l1.6 3-93.8 129 98 98 129-93.8 3 1.6c17 9 34.6 16.3 52.7 22l4 1.2v3.6L430 969.7z"/><path d="M586 990H412.7l-26-160c-13.2-4.6-26.4-10-39-16.3l-132.8 96.7L92.2 788 189 655c-6.4-13-12-26.5-16.6-40.2L10 589.3V416l162.3-25.6c4.8-14 10.5-27.8 17.2-41.2l-98-134.4L214 92.2l135.3 98.4c12-5.8 24.6-11 37.2-15.4l26-165.3H586l26 164.8c13.4 4.6 26.7 10 39.6 16.3l133.7-96.2 122.4 122.4L811.4 351c6 12.5 11.5 25.4 16 38.5L990 416v173.2l-162.6 26.5c-4.4 12.7-9.6 25.3-15.5 37.5l95 132-122.4 122.4-131.2-94.5C640 820 626 825.7 612 830.5L586 990zm-148-29.6h123l25-152.6 8.8-2.7c18.3-5.7 36.2-13.2 53.4-22.2l8-4.2L781.6 869l87-87-87-120-4.8-4.8 5-9.6c8.3-16 15.3-33 20.7-50.3l3.2-10.4h12.8l142-23.2V441.2L817.2 418H805.4l-3.3-10.4c-5.5-17.7-12.7-35-21.3-51.4l-5-9.6 9-9 84-117-87-87L661 222 656 227l-9.6-5c-16.7-8.8-34.3-16-52-21.6l-8.8-2.7-25-158H438l-23.4 148.8.1 9-10.3 3.3c-17 5.4-33.7 12.3-49.6 20.5l-9.6 5-7.6-7.6L217.2 131l-86.8 86.8 93.8 128.8-4.3 8c-9 17-16.5 35-22.2 53.2l-2.7 8.8-155.4 24.5V564L195 588.4l2.7 8.8c5.6 18 13 35.5 21.7 52.3l4.3 8L131 784.8l86.8 86.8L345 779l8 4.2c16.4 8.6 33.6 15.8 51.2 21.4l10.3 3.3v10.4l23.3 142zm61.5-260c-109.7 0-199-89.2-199-199s89.2-199 199-199 199 89.2 199 199c.1 109.6-89.2 199-199 199zm0-387c-103.6 0-188 84.3-188 188s84.3 188 188 188 188-84.3 188-188-84.3-188-188-188zm0 396c-114.8 0-208.2-93.4-208.2-208.2s93.4-208.2 208.2-208.2 208.2 93.4 208.2 208.2-93.4 208.2-208.2 208.2zm0-386.8c-98.5 0-178.6 80-178.6 178.6S401 680 499.4 680 678 600 678 501.5C678 403 598 323 499.4 323z"/></svg>
					<span class="navigation-title">{{$t('settings')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<div class="field">
					<div class="container">
						<div class="content">
							<div class="field-inner">
								<label for="language">{{$t('language')}}</label>
								<div class="element">
									<select v-model="$settings.data.language" id="language" @change="save">
										<option value="en-US">English</option>
										<option value="it-IT">Italiano</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="field">
					<div class="container">
						<div class="content">
							<div class="field-inner">
								<label for="default-yarn-count">{{$t('default-yarn-count')}}</label>
								<div class="element">
									<select v-model="$settings.data.defaultYarnCount" id="default-yarn-count" @change="save">
										<option
											v-for="(unit, index) in $yarnCountUtils.units"
											:key="'unit-'+index"
											:value="unit.code"
										>
											{{$t(unit.name)}}
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="field">
					<div class="container">
						<div class="content">
							<div class="field-inner">
								<label for="default-yarn-type">{{$t('default-yarn-type')}}</label>
								<div class="element">
									<select v-model="$settings.data.defaultYarnType" id="default-yarn-type" @change="save">
										<option
											v-for="(type, index) in $yarnUtils.types"
											:key="'type-'+index"
											:value="type.code"
										>
											{{$t(type.name)}}
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</transition>
	</div>
</template>

<script>
export default {
	methods: {
		save() {
			this.$utils.saveSettings();
		}
	}
}
</script>